import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si no entiendo nada de finanzas?',
    a: 'Sí. El sistema está diseñado específicamente para personas que no tienen conocimientos financieros previos. Cada estrategia tiene pasos numerados, ejemplos con números reales argentinos y checklists para ejecutar sin análisis previo.'
  }, {
    q: '¿Funciona con sueldo mínimo o ingreso muy ajustado?',
    a: 'Sí. El sistema se adapta a cualquier nivel de ingreso. Incluso con $200.000 mensuales hay herramientas que generan resultados reales. El Tomo 5 también enseña a crear una segunda fuente de ingresos independientemente del sueldo actual.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un correo en tu casilla con el acceso a los 6 Tomos y los 6 Bonos en formato PDF. Todo descargable de por vida. Sin plataformas. Sin contraseñas adicionales.'
  }, {
    q: '¿Necesito aplicaciones de pago o cuentas especiales?',
    a: 'No necesitás nada previamente. El Tomo 1 incluye el paso a paso para configurar desde cero todas las billeteras y cuentas que el sistema usa. Desde la primera instalación.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Si aplicás el sistema durante 7 días y no es lo que esperabas, mandás un mail y te devolvemos el 100%. Sin formularios. Sin burocracia.'
  }, {
    q: '¿Es legal? ¿Algo de esto me puede meter en problemas?',
    a: 'Todo el sistema está dentro del marco legal argentino. El MEP (dólar bolsa) es completamente legal. Las estrategias de billeteras, cashback, negociación bancaria y generación de ingresos no tienen ninguna implicancia legal negativa.'
  }, {
    q: '¿Qué diferencia hay entre el Sistema base y el Sistema + Acelerador?',
    a: 'El Sistema base te da el control completo de tus finanzas. El Acelerador es la capa de herramientas que automatiza la gestión, recupera $30.000-$60.000 mensuales en costos renegociados y te da el sistema para escalar los ingresos a retenciones en USD. Si querés resultados grandes y rápidos, el Acelerador lo multiplica.'
  }];
  return <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-115">
      <FadeIn data-id="element-116">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-117">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.2)]" data-id="element-118">
            ❓
          </span>{' '}
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-119">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-120" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-white border-[#22c55e] shadow-[0_5px_15px_rgba(34,197,94,0.1)]' : 'bg-white border-[#e2e8f0] hover:border-[#22c55e]/50 shadow-sm'}`} data-id="element-121">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-4 md:py-6 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-122">
        <span className={`font-black text-sm md:text-xl pr-2 md:pr-4 transition-colors ${isOpen ? 'text-[#16a34a]' : 'text-[#0f172a]'}`} data-id="element-123">
          {question}
        </span>
        <div className={`shrink-0 p-1.5 md:p-2 rounded-full transition-colors ${isOpen ? 'bg-[#22c55e]/20 text-[#16a34a]' : 'bg-[#f1f5f9] text-[#475569]'}`} data-id="element-124">
          {isOpen ? <Minus className="w-4 h-4 md:w-5 md:h-5" data-id="element-125" /> : <Plus className="w-4 h-4 md:w-5 md:h-5" data-id="element-126" />}
        </div>
      </button>
      <AnimatePresence data-id="element-127">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-128">
            <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-129">
              <p className="text-[#475569] leading-relaxed text-sm md:text-lg font-medium" data-id="element-130">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}